<!-- Bar Settings -->
@if (isBarWidget) {
  <div>
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label translate>Y-axis label</label>
          <input (change)="onAxisLabelChange()"
            [(ngModel)]="userDefinedWidget.userDefinedChartDetails.axisYLabel"
               [ngClass]="{
                      'is-invalid': isAxisNameNotSet,
                       'is-valid':!isAxisNameNotSet
                       }"
            [placeholder]="'Enter label ...'|translate"
            class="form-control" type="text">
          </div>
        </div>
        <div class="col-6">
          <scitis-widget-axis-range-settings
            (rangeChanged)="onAxisRangeChanged($event)"
            [maxY]="userDefinedWidget.userDefinedChartDetails.maxY"
            [minY]="userDefinedWidget.userDefinedChartDetails.minY">
          </scitis-widget-axis-range-settings>
        </div>
      </div>
      <scitis-widget-configuration-signals-selector
        (signalSelectionChanged)="onSignalSelected($event)"
        [items]="usableSignals"
        [multiSelection]="true"
        [selectedSignalsIds]="selectedSignalIds"
        [showColor]="false"
        [validate]="false">
      </scitis-widget-configuration-signals-selector>
      <span class="form-label" translate>Configure selected signals</span>
      @if (!userDefinedWidget.userDefinedChartDetails.signals || userDefinedWidget.userDefinedChartDetails.signals.length===0) {
        <div
          class="alert alert-info text-center">
          <span translate>Currently no signals have been added, please add one from above.</span>
        </div>
      }
      <ul [(dragulaModel)]="userDefinedWidget.userDefinedChartDetails.signals"
        [dragula]="dragAndDropItems"
        class="list-group mb-3">
        @for (signal of userDefinedWidget.userDefinedChartDetails.signals; track signal) {
          <scitis-bar-widget-signal-item
            (signalDeleteEvent)="onSignalRemove($event)"
            (signalStartEditEvent)="onSignalStartEdit($event)"
            [isSelectedSignal]="this.selectedSignalForEdit.get(signal.signalId)"
            [signalHasBeenDeleted]="hasSignalBeenDeleted(signal)"
            [signal]="signal">
          </scitis-bar-widget-signal-item>
        }
      </ul>
      @if (hasDeletedSignalsMap.get(userDefinedWidget.id+'') ?? false) {
        <div class="d-flex align-items-center justify-content-center mb-0 mt-2 alert alert-warning text-center">
          <em class="fa-solid fa-circle-exclamation mr-2"></em>
          <span translate>Signals that have been deleted in the asset configuration have to be removed from the axis.</span>
        </div>
      }
    </div>
  }
